import React from "react";

export default React.memo(({ intl, ...props }) => {
  const { label, options, name, cssStyle } = props;

  const handleOnChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    props.selectedCustomFilters((prevCustomFilters) => {
      return {
        ...prevCustomFilters,
        [name]: value,
      };
    });
  };

  return (
    <>
      {
        <div className="d-flex">
          <span className="p-1 text-nowrap" style={cssStyle}>
            {label}:{" "}
          </span>
          {options && options.length > 0 && (
            <select
              className="user-input ml-1 p-1"
              name={name}
              onChange={handleOnChange}
            >
              {React.Children.toArray(
                options.map((option) => {
                  return <option value={option.value}>{option.label}</option>;
                })
              )}
            </select>
          )}
        </div>
      }
    </>
  );
});
